import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {CommandService} from '@core/services/command.service';
import {Subject} from 'rxjs';
import {
  ChecklistItem,
  ChecklistModel
} from '../../models/task-manager.model';
import {FileManagementService} from '@core/services/file-management.service';
import {DownloadFileCommand} from '../../../file-manager/commands/create-directory.command';

@Component({
    standalone: false,
    selector: 'particle-task-checklist-item-attachment',
  templateUrl: './task-checklist-item-attachment.component.html',
  styleUrls: ['./task-checklist-item-attachment.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TaskChecklistItemAttachmentComponent implements OnInit {
  @Input() disabled?: boolean;
  @Input() checklistItem: ChecklistItem;
  @Input() task: any;

  constructor(protected commandService: CommandService,
              protected fileManagementService: FileManagementService
  ) {
  }

  ngOnInit() {
  }


  download() {
    const downloadFileCommand = new DownloadFileCommand(this.checklistItem.attachment.attachmentId, '', true);
    downloadFileCommand.ticketId = this.task.id;
    downloadFileCommand.scope = this.task.scopeInt;
    this.commandService.executeCommand(downloadFileCommand).pipe().subscribe(data => {
      console.log('Download File', data);
      this.fileManagementService.downloadOneTimeSignedUrl(data.Payload['DownloadUrl'], data.Payload['FileName']);
    });

  }

}
